import type { TranslatePlural } from '@shared/types/i18n/translation-service';

type Parameters = {
  adults: number;
  rooms: number;
  childrenAges?: number[];
  translatePlural: TranslatePlural;
};

const getGuestsRoomsChildrenValue = ({
  adults,
  childrenAges,
  rooms,
  translatePlural,
}: Parameters) => {
  const childrenLength = childrenAges && childrenAges.length;

  const adultsLabel = translatePlural(
    'HotelStay_label_adults_',
    adults,
    '0',
    null,
    9,
    'X',
  );

  const roomsLabel = translatePlural(
    'SelectionSummary_label_rooms',
    rooms,
    'number',
  );

  if (!childrenLength) {
    return `${adultsLabel}, ${roomsLabel}`;
  }

  const childrenLabel = translatePlural(
    'HotelStay_label_children_',
    childrenLength,
    'number',
  );

  return `${adultsLabel}, ${childrenLabel}, ${roomsLabel}`;
};

export default getGuestsRoomsChildrenValue;
